import React from 'react';
const Error = () => {
    return ( 
        <div>
             <h2>Error 404</h2>
        </div>
     );
}
 
export default Error;